import { useNavigate } from 'react-router-dom';
import '../styles/Cart.css';

const Cart = ({ cart, bundles = [], onClose, editable = false }) => {
  const navigate = useNavigate();
  
  // Find the selected bundle
  const selectedBundle = bundles.find(b => b.id === cart.bundle?.id) || cart.bundle;
  
  // Safely get item details
  const getItemDetails = (item) => {
    if (!item) return null;
    
    return {
      name: item.name || 'Additional Item',
      price: item.price || 0,
      color: item.selectedColor,
      size: item.selectedSize,
      firstLetter: item.name?.charAt(0) || 'A'
    };
  };

  // Calculate total price
  const calculateTotal = () => {
    let total = selectedBundle?.price || 0;
    
    // Add additional items prices
    const additionalItems = [cart.firstChoice, cart.secondChoice, cart.thirdChoice]
      .filter(item => item)
      .forEach(item => {
        total += item.price || 0;
      });
    
    return total;
  };

  const handleEdit = () => {
    onClose?.();
    navigate('/items');
  };

  return (
    <div className="cart-container">
      <div className="cart-header">
        <h2>Your Cart</h2>
        {onClose && (
          <button className="close-cart" onClick={onClose}>
            &times;
          </button>
        )}
      </div>
      
      <div className="cart-content">
        {/* Selected Bundle Section */}
        {selectedBundle ? (
          <div className="cart-section">
            <div className="section-header">
              <h3>Selected Bundle</h3>
              {editable && (
                <button 
                  className="edit-button"
                  onClick={() => navigate('/bundles')}
                >
                  Edit
                </button>
              )}
            </div>
            <div className="cart-item">
              {selectedBundle.image ? (
                <img 
                  src={selectedBundle.image} 
                  alt={selectedBundle.name} 
                  className="item-image"
                />
              ) : (
                <div className="item-image placeholder">
                  {selectedBundle.name?.charAt(0) || 'B'}
                </div>
              )}
              <div className="item-details">
                <h4>{selectedBundle.name || 'Bundle'}</h4>
                <p>${selectedBundle.price?.toFixed(2) || '0.00'}</p>
                {selectedBundle.details && <p>{selectedBundle.details}</p>}
              </div>
            </div>
          </div>
        ) : (
          <p className="no-items">No bundle selected</p>
        )}

        {/* Additional Items Section */}
        {(cart.firstChoice || cart.secondChoice || cart.thirdChoice) && (
          <div className="cart-section">
            <div className="section-header">
              <h3>Additional Items</h3>
              {editable && (
                <button 
                  className="edit-button"
                  onClick={handleEdit}
                >
                  Edit
                </button>
              )}
            </div>

            {[cart.firstChoice, cart.secondChoice, cart.thirdChoice]
              .filter(item => item)
              .map((item, index) => {
                const details = getItemDetails(item);
                if (!details) return null;
                
                return (
                  <div className="cart-item" key={`item-${index}`}>
                    <div className="item-image placeholder">
                      {details.firstLetter}
                    </div>
                    <div className="item-details">
                      <h4>{details.name}</h4>
                      <p>
                        {details.color && `Color: ${details.color}`}
                        {details.size && ` | Size: ${details.size}`}
                      </p>
                      <p className="item-price">${details.price.toFixed(2)}</p>
                    </div>
                  </div>
                );
              })}
          </div>
        )}
      </div>
      
      <div className="cart-footer">
        <div className="total-section">
          <span>Total:</span>
          <span className="total-price">${calculateTotal().toFixed(2)}</span>
        </div>
        
        {selectedBundle && (
          <button 
            className="checkout-button"
            onClick={() => navigate('/confirmation')}
          >
            Proceed to Checkout
          </button>
        )}
      </div>
    </div>
  );
};

export default Cart;